function OptChk(THS){
  var CBL = document.getElementsByClassName("MRSN-CHECK_CLS").length;
  var ANS = "";
  document.getElementById("properties[オプション]").value = "";
  for(var i = 0;i < CBL; i++){
    var CCC = document.getElementsByClassName("MRSN-CHECK_CLS")[i];
    var CHK = CCC.checked;
    if(CHK == true){
      var Opt = CCC.value;
      var ANS = ANS + Opt + "," + "\n" ;
    };
  };
  if(ANS != ""){
    document.getElementById("properties[オプション]").value = ANS;
    document.getElementById("RCcheck").required = false;
  }else{
    document.getElementById("properties[オプション]").value = "";
    document.getElementById("RCcheck").required = true;
  };
};

function LstChk(ts){
  ts.checked = false;
}